import { Component, h } from 'preact';
import { Inquiry } from 'inquiries';
import { formatAsColloquialDate } from '../../../../core/date-formatter';

interface InquiryCompactClientInfoProps {
  inquiry: Inquiry;
}

export class InquiryCompactClientInfo extends Component<InquiryCompactClientInfoProps> {
  render() {
    const inquiry = this.props.inquiry;
    return (
      <div className="hi-inqcclinfo">
        <span className="hi-inqcclinfo__inq-id">{ inquiry.inquiryCode }</span>
        <span className="hi-inqcclinfo__client-name">{ inquiry.client.name }</span>
      </div>
    );
  }
}
